import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import FeatureCard from 'marketplace-ui-apps-core/details/components/FeatureCard';
import { FeatureCardCompatibility } from './FeatureCardCompatibility';
// @ts-expect-error untyped dependency
import { getIsCustomer } from '../../../selectors/auth';
import { getMissingCompatibilityRequirements } from 'marketplace-ui-apps-core/installability/utils/featureCompatibilities';
import { jsx as _jsx } from "react/jsx-runtime";
export function FeatureCards({
  features,
  installability,
  onTrackInteraction
}) {
  const isCustomer = useSelector(getIsCustomer);
  const missingCompatibilityRequirements = getMissingCompatibilityRequirements(features, installability);
  return /*#__PURE__*/_jsx(Fragment, {
    children: features.map((feature, index) => {
      const missingCompatibilityRequirement = missingCompatibilityRequirements && missingCompatibilityRequirements[index];
      return /*#__PURE__*/_jsx(FeatureCard, {
        className: "m-bottom-8",
        feature: feature,
        onImageClick: () => onTrackInteraction('click integration feature screenshot', {
          section: 'overview'
        }),
        children: isCustomer && installability ? /*#__PURE__*/_jsx(FeatureCardCompatibility, {
          onTrackInteraction: onTrackInteraction,
          missingCompatibilityRequirement: missingCompatibilityRequirement
        }) : null
      }, feature.id);
    })
  });
}